import React, { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import ForexCard from "../../../assets/ForexCard.png";
import EducationLoan from "../../../assets/EducationLoan.png";
import AccomodationImage from "../../../assets/Accomodation.png";
import Insurance from "../../../assets/Insurance.png";
import { applyLoan } from "../../../services/user.services";
import { IconLoader2 } from "@tabler/icons-react";

function MainForex() {
  const navigate = useNavigate();
  const location = useLocation();

  // Track loading state for each button
  const [loadingStates, setLoadingStates] = useState({
    forex: false,
    "education-loan": false,
    accomodation: false,
    insurance: false,
  });

  const handleApply = async (type, route) => {
    // Set loading state for this specific button
    setLoadingStates((prev) => ({ ...prev, [type]: true }));

    const loanData = {
      loan_type: type, // or country_proof if that's the expected field
    };

    try {
      const response = await applyLoan(loanData);
      // You can show a toast/snackbar or alert if needed
      navigate(route); // Navigate after successful application
    } catch (error) {
      console.error("Loan Application Failed:", error);
      alert(
        error.response?.data?.error || "Failed to apply. Please try again."
      );
    } finally {
      // Reset loading state regardless of success or failure
      setLoadingStates((prev) => ({ ...prev, [type]: false }));
    }
  };

  return (
    <>
      {location.pathname === "/student/mainForex" && (
        <div className="p-6 flex-1 min-h-screen">
          <h1 className="text-3xl font-bold mb-6">
            Apply for Forex, Loans, and More
          </h1>
          <div className="flex flex-wrap justify-center gap-5">
            <div className="bg-white p-4 rounded-lg shadow-md text-center flex-1 min-w-[300px]">
              <img
                src={ForexCard}
                alt="Forex Card"
                className="mx-auto mb-4 w-[215px] h-[227px]"
              />
              <h3 className="text-lg font-semibold">
                Forex Card and Remittance
              </h3>
              <button
                className="mt-4 bg-green-500 text-white p-2 rounded-lg w-32 mx-auto flex items-center justify-center"
                onClick={() => handleApply("forex", "/student/mainForex/forex")}
                disabled={loadingStates.forex}
              >
                {loadingStates.forex ? (
                  <>
                    <IconLoader2 className="animate-spin mr-2" size={18} />
                    Processing...
                  </>
                ) : (
                  "Apply Now"
                )}
              </button>
            </div>
            <div className="bg-white p-4 rounded-lg shadow-md text-center flex-1 min-w-[300px]">
              <img
                src={EducationLoan}
                alt="Education Loan"
                className="mx-auto mb-4 w-[215px] h-[227px]"
              />
              <h3 className="text-lg font-semibold">Education Loan</h3>
              <button
                className="mt-4 bg-green-500 text-white p-2 rounded-lg w-32 mx-auto flex items-center justify-center"
                onClick={() =>
                  handleApply(
                    "education-loan",
                    "/student/mainForex/education-loan"
                  )
                }
                disabled={loadingStates["education-loan"]}
              >
                {loadingStates["education-loan"] ? (
                  <>
                    <IconLoader2 className="animate-spin mr-2" size={18} />
                    Processing...
                  </>
                ) : (
                  "Apply Now"
                )}
              </button>
            </div>
            <div className="bg-white p-4 rounded-lg shadow-md text-center flex-1 min-w-[300px]">
              <img
                src={AccomodationImage}
                alt="Accommodation"
                className="mx-auto mb-4 w-[215px] h-[227px]"
              />
              <h3 className="text-lg font-semibold">Accommodations</h3>
              <button
                className="mt-4 bg-green-500 text-white p-2 rounded-lg w-32 mx-auto flex items-center justify-center"
                onClick={() =>
                  handleApply("accomodation", "/student/accomodations")
                }
                disabled={loadingStates.accomodation}
              >
                {loadingStates.accomodation ? (
                  <>
                    <IconLoader2 className="animate-spin mr-2" size={18} />
                    Processing...
                  </>
                ) : (
                  "Apply Now"
                )}
              </button>
            </div>
            <div className="bg-white p-4 rounded-lg shadow-md text-center flex-1 min-w-[300px]">
              <img
                src={Insurance}
                alt="Insurance"
                className="mx-auto mb-4 w-[215px] h-[227px]"
              />
              <h3 className="text-lg font-semibold">Insurance</h3>
              <button
                className="mt-4 bg-green-500 text-white p-2 rounded-lg w-32 mx-auto flex items-center justify-center"
                onClick={() =>
                  handleApply("insurance", "/student/mainForex/insurance")
                }
                disabled={loadingStates.insurance}
              >
                {loadingStates.insurance ? (
                  <>
                    <IconLoader2 className="animate-spin mr-2" size={18} />
                    Processing...
                  </>
                ) : (
                  "Apply Now"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      <Outlet />
    </>
  );
}

export default MainForex;
